/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Pdf_Lexique_To_Install_ValveInputs */



/**
* | output |
* | --- |
* | "Install thermostatic head" |
*
* @param {Intervention_Plan_Pdf_Lexique_To_Install_ValveInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_pdf_lexique_to_install_valve = /** @type {((inputs?: Intervention_Plan_Pdf_Lexique_To_Install_ValveInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Pdf_Lexique_To_Install_ValveInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Install thermostatic head")
	return /** @type {LocalizedString} */ ("Installer la tête th.")
});